// TODO need to add test for this and nested components
import React, {PureComponent, ReactNode} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';
import {CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE} from 'constants/analytics/events/cartUpgrade';

import {CoverageChoice} from './coverageChoice/coverageChoice';
import {CoverageTable} from './coverageTable/coverageTable';

import s from './enhancedCoverageOneYear.scss';

type PropsType = {
    workingTime?: string;
    lensType?: string;
    price: number;
    phone: string;
    copayPrice: string;
    isSelected: boolean;
    handleClick: null | ((place?: string) => ReactNode);
};

/**
 * Enhanced coverage popup.
 * Content of popup is contained in CoverageTable component.
 * CoverageChoice will be showed if handleClick will be passed to props.
 */
export class EnhancedCoverageOneYear extends PureComponent<PropsType> {
    static defaultProps = {
        lensType: 'Premium marked frame Single Vision',
        workingTime: 'All Day. Every Day. 24-7',
    };

    /*
     * Add or remove upsell and send analytics
     */
    onSendAnalytics = (place: string) => {
        const {handleClick, isSelected} = this.props;
        if (handleClick) handleClick();
        sendDesktopAnalyticsEvent(CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE, {
            action: isSelected ? 'Remove' : 'Add',
            place,
        });
    };

    /**
     * Render jsx to html
     * @returns {ReactNode} Rendered react component
     */
    render(): ReactNode {
        const {copayPrice, handleClick, isSelected, lensType, phone, price, workingTime} =
            this.props;
        const coverageChoice = handleClick
            ? (place: string) => (
                  <CoverageChoice
                      isSelected={isSelected}
                      onToggle={() => this.onSendAnalytics(place)}
                      phone={phone}
                  />
              )
            : null;
        return (
            <div className={s.enhancedCoverage} data-test-name="insurancePopup">
                <header className={s.header}>
                    <CloudinaryImage
                        alt="logo"
                        height="86"
                        id="insurance-popup-logo"
                        src={require('./img/enhancedCoverage-logo.png')}
                        width="87"
                    />
                    <h1 className={s.title}>20/20 Enhanced Coverage</h1>
                    <h2 className={s.subtitle}>One Year warranty</h2>
                </header>

                <CoverageTable
                    copayPrice={copayPrice}
                    coverageChoice={coverageChoice}
                    lensType={lensType as string}
                    phone={phone}
                    price={price}
                    workingTime={workingTime as string}
                />

                <footer className={s.footer}>
                    * The customer is entitled to a one time replacement of the same frame (or equal
                    valued frame) with same lens package and coatings as in the original order. If a
                    prescription change requires an upgrade in lens package, the customer will pay
                    the difference. Product must be returned to GlassesUSA prior to exchange. A
                    Co-Pay amount of <Price>{copayPrice}</Price> will be charged by GlassesUSA.com
                    for any exchange within this coverage. For full details see our Terms and
                    Conditions
                </footer>
            </div>
        );
    }
}
